export default ngModule => {

  ngModule.directive('fundFilters', (AonConfig) => {
    return {
      restrict: 'E',
      scope: {
        title: '@',
        isExpanded: '=',
        onToggleOpen: '=',
        onToggleAll: '=',
        filterModel: '=',
        modelField: '@',
        funds: '=',
        onRefresh: '=',
        splitOpenRestricted: '='
      },
      template: require('../partials/fund-filters.html'),
      link: (scope) => {
      }
    };
  });
}



// WEBPACK FOOTER //
// ./src/directives/fund-filters.js